import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '@/app/providers/auth-provider';
import { AGENT_SCOPE_FIXED, AGENT_SCOPE_QUERY, storeAgentScope, } from '@/shared/model/agent-scope';
export function useAgentScope() {
    const { user } = useAuth();
    const [searchParams, setSearchParams] = useSearchParams();
    const defaultScope = AGENT_SCOPE_FIXED;
    const scope = AGENT_SCOPE_FIXED;
    const setScope = useCallback((_next) => {
        storeAgentScope(AGENT_SCOPE_FIXED);
        const params = new URLSearchParams(searchParams);
        params.set(AGENT_SCOPE_QUERY, AGENT_SCOPE_FIXED);
        setSearchParams(params, { replace: true });
    }, [searchParams, setSearchParams]);
    return useMemo(() => ({
        scope,
        setScope,
        isAdmin: user?.isAdmin ?? false,
        defaultScope,
    }), [scope, setScope, user?.isAdmin, defaultScope]);
}
